<div class="advanced-analysis-container">
  <div class="temporal-analysis-container">
    <div class="advanced-analysis-panel">
      @if (hasNullData()) {
        <div class="chart-controls">
          <label class="annotation-toggle">
            <input
              type="checkbox"
              [checked]="annotationToggles().nullPoints"
              (change)="toggleAnnotation('nullPoints')" />
            Destacar períodos sem dados
          </label>
        </div>
      }
      <div class="advanced-analysis-chart">
        <div class="chart-stage">
          <div #analysisChart echarts [options]="chartOptions" class="chart"></div>
          @if (annotationToggles().nullPoints && hasNullData()) {
            <div class="chart-annotation-legend" aria-label="Legenda das anotações">
              <span class="chart-annotation-legend__swatch" aria-hidden="true"></span>
              <span class="chart-annotation-legend__label">Período sem dados</span>
            </div>
          }
        </div>
      </div>
    </div>
  </div>
</div>
